import { clearFilterParams, useCleanFilterForRequest } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import { path } from 'ramda'
import React from 'react'

import { accountsClient } from '../../utils/apollo/api'
import { usePromiseQuery } from '../../utils/apollo/_helpers/promiseQuery'
import LazySelectAllLinkApollo from '../../components/actions/LazySelectAllLinkApollo'

const QUERY = gql`
  query Users($search: String, $filter: UserFilter) {
    users(limit: 9000000, search: $search, filter: $filter) {
      id
    }
  }
`

export const useGetAllUsers = () => {
  const filter = useCleanFilterForRequest()
  const call = usePromiseQuery(QUERY, {
    variables: { filter },
    client: accountsClient
  })
  return () => call().then(path(['data', 'users']))
}

//TODO: Use useGetAllUsers func
const SelectAllUsersLink = ({ search, filter, ...props }) => {
  return (
    <LazySelectAllLinkApollo
      query={QUERY}
      variables={{ search, filter: { ...clearFilterParams(filter || {}), ignoreSegments: true } }}
      client={accountsClient}
      {...props}
    />
  )
}

export default SelectAllUsersLink
